"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteWorkspaceViewsPreference = void 0;
var tslib_1 = require("tslib");
var noop_1 = (0, tslib_1.__importDefault)(require("lodash/fp/noop"));
var ViewPreferenceApiService_1 = require("../services/ViewPreferenceApiService");
var useDeleteWorkspaceViewsPreference = function (app) {
    var deleteWorkspaceViews = function (workspaceId, onCompleted, onError) {
        if (onCompleted === void 0) { onCompleted = noop_1.default; }
        if (onError === void 0) { onError = noop_1.default; }
        return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var url, res;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/workspace-views/{clientId}/{userId}/".concat(workspaceId, "?app=").concat(app);
                        return [4 /*yield*/, ViewPreferenceApiService_1.ViewPreferenceApiService.delete(url).then(onCompleted, onError)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    return [deleteWorkspaceViews];
};
exports.useDeleteWorkspaceViewsPreference = useDeleteWorkspaceViewsPreference;
